<div class="sign-up-container">
  <div *ngIf="(sessionResolved | async) === false || undefined || null">
    <h2>Thank you!  Please wait while we provision your subscription...</h2>
  </div>

  <div *ngIf="sessionResolved | async">
    <h2>Your subscription is provisioned!  Let's get started!</h2>
  </div>
</div>
